/* KORSMOS — interacciones propias (sin librerías) */
(function () {
  'use strict';
  var reduce = window.matchMedia('(prefers-reduced-motion: reduce)').matches;
  var observer = null;

  /* ---------- Titulares que aparecen palabra a palabra ---------- */
  function splitWords(el) {
    if (el.dataset.ksSplit) return;
    el.dataset.ksSplit = '1';
    var i = 0;
    function walk(node) {
      Array.prototype.slice.call(node.childNodes).forEach(function (child) {
        if (child.nodeType === 3) {
          var frag = document.createDocumentFragment();
          child.textContent.split(/(\s+)/).forEach(function (part) {
            if (!part) return;
            if (/^\s+$/.test(part)) { frag.appendChild(document.createTextNode(' ')); return; }
            var w = document.createElement('span');
            w.className = 'ks-w';
            var inner = document.createElement('span');
            inner.style.setProperty('--ks-i', i++);
            inner.textContent = part;
            w.appendChild(inner);
            frag.appendChild(w);
          });
          node.replaceChild(frag, child);
        } else if (child.nodeType === 1 && child.tagName !== 'BR') {
          walk(child);
        }
      });
    }
    walk(el);
  }

  /* ---------- Aparición al hacer scroll + cifras ---------- */
  function countUp(el) {
    if (el.dataset.ksDone) return;
    el.dataset.ksDone = '1';
    var target = parseFloat(el.dataset.ksCount) || 0;
    var decimals = (el.dataset.ksCount.split('.')[1] || '').length;
    var dur = 1800, start = null;
    if (reduce) { el.textContent = format(target, decimals); return; }
    function step(ts) {
      if (!start) start = ts;
      var p = Math.min((ts - start) / dur, 1);
      var eased = 1 - Math.pow(1 - p, 4);
      el.textContent = format(target * eased, decimals);
      if (p < 1) requestAnimationFrame(step);
    }
    requestAnimationFrame(step);
  }
  function format(n, d) {
    return n.toLocaleString('en-US', { minimumFractionDigits: d, maximumFractionDigits: d });
  }

  function initReveal(root) {
    root = root || document;
    root.querySelectorAll('.ks-words').forEach(splitWords);
    var els = root.querySelectorAll('.ks-reveal, .ks-words, [data-ks-count]');
    if (reduce || !('IntersectionObserver' in window)) {
      els.forEach(function (el) { el.classList.add('ks-visible'); if (el.dataset.ksCount) countUp(el); });
      return;
    }
    if (!observer) {
      observer = new IntersectionObserver(function (entries) {
        entries.forEach(function (e) {
          if (!e.isIntersecting) return;
          e.target.classList.add('ks-visible');
          if (e.target.dataset.ksCount) countUp(e.target);
          observer.unobserve(e.target);
        });
      }, { threshold: 0.12, rootMargin: '0px 0px -40px 0px' });
    }
    els.forEach(function (el) { observer.observe(el); });
  }

  /* ---------- Parallax suave ---------- */
  var parallaxEls = [];
  function initParallax() {
    parallaxEls = Array.prototype.slice.call(document.querySelectorAll('[data-ks-parallax]'));
  }
  function runParallax() {
    if (reduce) return;
    var vh = window.innerHeight;
    parallaxEls.forEach(function (el) {
      var box = el.parentElement.getBoundingClientRect();
      if (box.bottom < 0 || box.top > vh) return;
      var k = parseFloat(el.dataset.ksParallax) || 0;
      var progress = (box.top + box.height / 2 - vh / 2) / vh;
      var extra = el.dataset.ksScale || 1.12;
      el.style.transform = 'translate3d(0,' + (progress * k * -100).toFixed(2) + 'px,0) scale(' + extra + ')';
    });
  }

  /* ---------- Cabecera ---------- */
  function initHeader() {
    var header = document.querySelector('.ks-header');
    if (!header) return;
    function onScroll() { header.classList.toggle('ks-scrolled', window.scrollY > 10); }
    onScroll();
    window.addEventListener('scroll', onScroll, { passive: true });
    var menu = document.querySelector('.ks-mobile-menu');
    if (!menu) return;
    document.querySelectorAll('[data-ks-menu-open]').forEach(function (b) {
      b.addEventListener('click', function () { menu.classList.add('ks-open'); document.body.style.overflow = 'hidden'; b.setAttribute('aria-expanded', 'true'); });
    });
    function closeMenu() { menu.classList.remove('ks-open'); document.body.style.overflow = ''; }
    document.querySelectorAll('[data-ks-menu-close]').forEach(function (b) {
      b.addEventListener('click', closeMenu);
    });
    // Enlaces del menú: cerrar el menú y, si la sección está en esta página, bajar hasta ella
    menu.querySelectorAll('a').forEach(function (a) {
      a.addEventListener('click', function (e) {
        var url = new URL(a.href, window.location.href);
        var target = url.hash && url.pathname === window.location.pathname ? document.querySelector(url.hash) : null;
        closeMenu();
        if (!target) return;
        e.preventDefault();
        setTimeout(function () {
          target.scrollIntoView({ behavior: reduce ? 'auto' : 'smooth', block: 'start' });
          if (window.history && window.history.replaceState) window.history.replaceState(null, '', url.hash);
        }, 350);
      });
    });
  }

  /* ---------- Carruseles ---------- */
  function initCarousels(root) {
    (root || document).querySelectorAll('.ks-carousel').forEach(function (c) {
      if (c.dataset.ksInit) return;
      c.dataset.ksInit = '1';
      var track = c.querySelector('.ks-carousel__track');
      if (!track) return;
      var prev = c.querySelector('[data-ks-prev]');
      var next = c.querySelector('[data-ks-next]');
      function by() { var item = track.children[0]; return item ? item.getBoundingClientRect().width + 16 : 300; }
      if (prev) prev.addEventListener('click', function () { track.scrollBy({ left: -by(), behavior: 'smooth' }); });
      if (next) next.addEventListener('click', function () { track.scrollBy({ left: by(), behavior: 'smooth' }); });
    });
  }

  /* ---------- Página de producto ---------- */
  function initProduct(root) {
    (root || document).querySelectorAll('[data-ks-product]').forEach(function (wrap) {
      if (wrap.dataset.ksInit) return;
      wrap.dataset.ksInit = '1';

      // Galería
      var main = wrap.querySelector('.ks-gallery__main img');
      var thumbs = Array.prototype.slice.call(wrap.querySelectorAll('.ks-gallery__thumb'));
      var current = 0;
      function show(i) {
        if (!main || !thumbs.length) return;
        current = (i + thumbs.length) % thumbs.length;
        var t = thumbs[current];
        thumbs.forEach(function (x) { x.classList.remove('is-active'); });
        t.classList.add('is-active');
        t.scrollIntoView({ block: 'nearest', inline: 'nearest' });
        main.classList.add('is-fading');
        setTimeout(function () {
          main.src = t.dataset.src;
          main.srcset = '';
          main.alt = t.dataset.alt || '';
          main.onload = function () { main.classList.remove('is-fading'); };
          setTimeout(function () { main.classList.remove('is-fading'); }, 350);
        }, 180);
      }
      thumbs.forEach(function (t, i) { t.addEventListener('click', function () { show(i); }); });
      var gp = wrap.querySelector('[data-ks-gprev]');
      var gn = wrap.querySelector('[data-ks-gnext]');
      if (gp) gp.addEventListener('click', function () { show(current - 1); });
      if (gn) gn.addEventListener('click', function () { show(current + 1); });

      // Cantidad
      var qty = wrap.querySelector('.ks-qty input');
      wrap.querySelectorAll('[data-ks-qty]').forEach(function (b) {
        b.addEventListener('click', function () {
          if (!qty) return;
          var v = (parseInt(qty.value, 10) || 1) + parseInt(b.dataset.ksQty, 10);
          qty.value = Math.max(1, v);
        });
      });

      // Variantes
      var dataEl = wrap.querySelector('[data-ks-variants]');
      if (dataEl) {
        var variants = JSON.parse(dataEl.textContent);
        var idInput = wrap.querySelector('form input[name="id"]');
        var btn = wrap.querySelector('[data-ks-add]');
        var btnText = btn ? btn.querySelector('span') : null;
        var priceEl = wrap.querySelector('[data-ks-price]');
        var compareEl = wrap.querySelector('[data-ks-compare]');
        var saveEl = wrap.querySelector('[data-ks-save]');
        var stickyPrice = document.querySelector('[data-ks-sticky-price]');
        var fmt = wrap.dataset.moneyFormat || '{{amount}} €';
        var txtAdd = wrap.dataset.txtAdd, txtSold = wrap.dataset.txtSold, txtNa = wrap.dataset.txtNa;
        var saveTpl = wrap.dataset.txtSave || '-[p]%';
        function money(cents) {
          var v = (cents / 100).toFixed(2);
          var comma = v.replace('.', ',');
          return fmt.replace(/\{\{\s*(\w+)\s*\}\}/, function (m, k) {
            if (k === 'amount_with_comma_separator') return comma;
            if (k === 'amount_no_decimals') return Math.round(cents / 100);
            if (k === 'amount_no_decimals_with_comma_separator') return Math.round(cents / 100);
            return v;
          });
        }
        function selected() {
          return Array.prototype.slice.call(wrap.querySelectorAll('.ks-opt')).map(function (fs) {
            var c = fs.querySelector('input:checked');
            var lbl = fs.querySelector('legend span');
            if (lbl && c) lbl.textContent = c.value;
            return c ? c.value : null;
          });
        }
        function update() {
          var opts = selected();
          var v = variants.find(function (x) { return x.options.every(function (o, i) { return o === opts[i]; }); });
          if (!v) {
            if (btn) { btn.disabled = true; if (btnText) btnText.textContent = txtNa; }
            return;
          }
          if (idInput) idInput.value = v.id;
          if (priceEl) priceEl.textContent = money(v.price);
          if (stickyPrice) stickyPrice.textContent = money(v.price);
          if (compareEl) {
            var on = v.compare_at_price && v.compare_at_price > v.price;
            compareEl.textContent = on ? money(v.compare_at_price) : '';
            compareEl.hidden = !on;
            if (saveEl) {
              saveEl.hidden = !on;
              if (on) saveEl.textContent = saveTpl.replace('[p]', Math.round((1 - v.price / v.compare_at_price) * 100));
            }
          }
          if (btn) {
            btn.disabled = !v.available;
            btn.removeAttribute('aria-disabled');
            if (btnText) btnText.textContent = v.available ? txtAdd : txtSold;
          }
          if (v.featured_media && main) {
            var idx = thumbs.findIndex(function (t) { return t.dataset.mediaId == v.featured_media.id; });
            if (idx > -1) show(idx);
          }
          if (window.history && window.history.replaceState) {
            var url = new URL(window.location.href);
            url.searchParams.set('variant', v.id);
            window.history.replaceState({}, '', url.toString());
          }
        }
        wrap.querySelectorAll('.ks-opt input').forEach(function (inp) { inp.addEventListener('change', update); });
      }

      // Personalización: contador y validación antes de añadir al carrito
      var countIn = wrap.querySelector('[data-ks-count-input]');
      var countOut = wrap.querySelector('[data-ks-count-out]');
      if (countIn && countOut) countIn.addEventListener('input', function () { countOut.textContent = countIn.value.length; countIn.classList.remove('is-invalid'); });
      var pf = wrap.querySelector('product-form');
      var pform = pf ? pf.querySelector('form') : null;
      if (pf && pform) {
        pf.addEventListener('submit', function (e) {
          var bad = Array.prototype.filter.call(pform.querySelectorAll('[required]'), function (f) {
            return f.type === 'file' ? !f.files.length : !f.value.trim();
          });
          if (!bad.length) return;
          e.preventDefault();
          e.stopImmediatePropagation();
          bad.forEach(function (f) { f.classList.add('is-invalid'); });
          bad[0].scrollIntoView({ behavior: 'smooth', block: 'center' });
          setTimeout(function () { bad[0].focus(); }, 400);
        }, true);
        pform.querySelectorAll('input[type="file"]').forEach(function (f) { f.addEventListener('change', function () { f.classList.remove('is-invalid'); }); });
      }

      // Vista previa en directo (foto + nombre sobre el producto)
      var pv = wrap.querySelector('[data-ks-preview]');
      if (pv) {
        var mainBox = wrap.querySelector('.ks-gallery__main');
        var sw = wrap.querySelector('[data-ks-pv-switch]');
        var pvImg = pv.querySelector('[data-ks-pv-img]');
        var pvPhoto = pv.querySelector('[data-ks-pv-photo]');
        var pvName = pv.querySelector('[data-ks-pv-name] span');
        var fileIn = wrap.querySelector('[data-ks-pv-file]');
        var textIn = wrap.querySelector('[data-ks-count-input]');
        var adjust = wrap.querySelector('[data-ks-pv-adjust]');
        var zoomIn = wrap.querySelector('[data-ks-pv-zoom]');
        var zoomOut = wrap.querySelector('[data-ks-pv-zoom-out]');
        var posOut = wrap.querySelector('[data-ks-pv-pos-out]');
        var pos = { x: 0, y: 0 }, zoom = 100, url = null;

        function mode(m) {
          var showPv = m === 'preview';
          pv.hidden = !showPv;
          mainBox.classList.toggle('is-previewing', showPv);
          if (sw) {
            sw.hidden = false;
            sw.querySelectorAll('button').forEach(function (b) { b.classList.toggle('is-active', b.dataset.ksPvShow === m); });
          }
        }
        function paint() {
          var z = zoom / 100, lim = (z - 1) / 2 * 100;
          pos.x = Math.max(-lim, Math.min(lim, pos.x));
          pos.y = Math.max(-lim, Math.min(lim, pos.y));
          pvImg.style.transform = 'translate(' + pos.x.toFixed(2) + '%, ' + pos.y.toFixed(2) + '%) scale(' + z + ')';
          if (zoomOut) zoomOut.value = zoom + '%';
          if (posOut) posOut.value = 'x ' + Math.round(pos.x) + '%, y ' + Math.round(pos.y) + '%';
        }
        if (sw) sw.querySelectorAll('button').forEach(function (b) {
          b.addEventListener('click', function () { mode(b.dataset.ksPvShow); });
        });
        thumbs.forEach(function (t) { t.addEventListener('click', function () { if (sw && !sw.hidden) mode('photos'); }); });

        if (fileIn) fileIn.addEventListener('change', function () {
          var f = fileIn.files && fileIn.files[0];
          if (!f) return;
          if (url) URL.revokeObjectURL(url);
          url = URL.createObjectURL(f);
          var probe = new Image();
          probe.onload = function () {
            pvImg.style.backgroundImage = 'url("' + url + '")';
            pos = { x: 0, y: 0 }; zoom = 100; if (zoomIn) zoomIn.value = 100;
            paint();
            pv.classList.add('has-photo');
            if (adjust) adjust.hidden = false;
            mode('preview');
            mainBox.scrollIntoView({ behavior: 'smooth', block: 'nearest' });
          };
          probe.onerror = function () {
            // Formatos que el navegador no puede mostrar (p. ej. HEIC): se sube igual, sin vista previa.
            pv.classList.remove('has-photo');
          };
          probe.src = url;
        });
        if (textIn) textIn.addEventListener('input', function () {
          var v = textIn.value.trim();
          pvName.textContent = v;
          pv.classList.toggle('has-name', v.length > 0);
          if (v.length > 0 && pv.hidden) mode('preview');
        });
        if (zoomIn) zoomIn.addEventListener('input', function () { zoom = parseInt(zoomIn.value, 10) || 100; paint(); });

        // Arrastrar la foto para encuadrarla
        var drag = null;
        pvPhoto.addEventListener('pointerdown', function (e) {
          if (!pv.classList.contains('has-photo')) return;
          drag = { x: e.clientX, y: e.clientY, px: pos.x, py: pos.y, w: pvPhoto.offsetWidth, h: pvPhoto.offsetHeight };
          pvPhoto.setPointerCapture(e.pointerId);
        });
        pvPhoto.addEventListener('pointermove', function (e) {
          if (!drag) return;
          if (zoom <= 100 && zoomIn) { zoom = 130; zoomIn.value = 130; }
          pos.x = drag.px + (e.clientX - drag.x) / drag.w * 100;
          pos.y = drag.py + (e.clientY - drag.y) / drag.h * 100;
          paint();
        });
        ['pointerup', 'pointercancel'].forEach(function (ev) { pvPhoto.addEventListener(ev, function () { drag = null; }); });
      }

      // Barra de compra fija (móvil)
      var sticky = document.querySelector('.ks-sticky-buy');
      var form = wrap.querySelector('.ks-buy form');
      if (sticky && form && 'IntersectionObserver' in window) {
        new IntersectionObserver(function (en) {
          var e = en[0];
          sticky.classList.toggle('ks-show', !e.isIntersecting && e.boundingClientRect.top < 0);
        }).observe(form);
        var sb = sticky.querySelector('button');
        if (sb) sb.addEventListener('click', function () {
          var real = wrap.querySelector('[data-ks-add]');
          if (real && !real.disabled) real.click();
          else form.scrollIntoView({ behavior: 'smooth', block: 'center' });
        });
      }
    });
  }

  /* ---------- Comparador antes / después ---------- */
  function initCompare(root) {
    (root || document).querySelectorAll('[data-ks-compare]').forEach(function (box) {
      if (box.dataset.ksInit) return;
      box.dataset.ksInit = '1';
      var range = box.querySelector('.ks-ba__range');
      if (!range) return;
      function set() { box.style.setProperty('--pos', range.value + '%'); }
      range.addEventListener('input', set);
      set();
    });
  }

  /* ---------- Packs: color (cambia la foto) + pack elegido + un solo botón ---------- */
  function initPackColors(root) {
    (root || document).querySelectorAll('[data-ks-packs]').forEach(function (box) {
      if (box.dataset.ksInit) return;
      box.dataset.ksInit = '1';
      var fmt = box.dataset.moneyFormat || '${{amount}}';
      var img = box.querySelector('[data-ks-pack-img]');
      var badge = box.querySelector('[data-ks-pack-badge]');
      var selQty = box.querySelector('[data-ks-pack-sel-qty]');
      var selColor = box.querySelector('[data-ks-pack-sel-color]');
      var colorName = box.querySelector('[data-ks-pack-color-name]');
      var idIn = box.querySelector('form input[name="id"]');
      var qtyIn = box.querySelector('form input[name="quantity"]');
      var btn = box.querySelector('.ks-packs__add');
      var btnText = btn ? btn.querySelector('span') : null;
      var swatches = Array.prototype.slice.call(box.querySelectorAll('.ks-swatch'));
      var packs = Array.prototype.slice.call(box.querySelectorAll('.ks-pack'));
      var active = box.querySelector('.ks-swatch.is-active');
      var price = active ? parseInt(active.dataset.price, 10) : null;
      var available = active ? active.dataset.available === 'true' : !(btn && btn.disabled);

      function money(cents) {
        var v = (cents / 100).toFixed(2);
        return fmt.replace(/\{\{\s*(\w+)\s*\}\}/, function (m, k) {
          if (k === 'amount_with_comma_separator') return v.replace('.', ',');
          if (k.indexOf('no_decimals') > -1) return Math.round(cents / 100);
          return v;
        });
      }
      function totals(qty, disc) {
        var full = price * qty;
        var final = full - Math.floor(full * disc / 100);
        return { full: full, final: final, each: Math.floor(final / qty) };
      }
      function refresh() {
        var r = box.querySelector('.ks-pack input:checked');
        var qty = r ? parseInt(r.value, 10) : 1;
        packs.forEach(function (pk) {
          var inp = pk.querySelector('input');
          pk.classList.toggle('is-selected', inp.checked);
          if (price == null) return;
          var t = totals(parseInt(inp.value, 10), parseInt(inp.dataset.discount, 10) || 0);
          pk.querySelector('[data-ks-pack-final]').textContent = money(t.final);
          pk.querySelector('[data-ks-pack-full]').textContent = money(t.full);
          var eachEl = pk.querySelector('[data-ks-pack-each]');
          eachEl.textContent = money(t.each) + ' ' + (eachEl.dataset.label || '');
        });
        if (qtyIn) qtyIn.value = qty;
        if (badge) { badge.textContent = '×' + qty; badge.hidden = qty < 2; }
        if (selQty && r) selQty.textContent = r.dataset.title;
        if (btn && btnText) {
          btn.disabled = !available;
          if (!available) btnText.textContent = btn.dataset.txtSold;
          else if (price != null && r) btnText.textContent = btn.dataset.txtAdd + ' · ' + money(totals(qty, parseInt(r.dataset.discount, 10) || 0).final);
        }
      }
      packs.forEach(function (pk) { pk.querySelector('input').addEventListener('change', refresh); });
      swatches.forEach(function (b) {
        if (b.dataset.img) { var pre = new Image(); pre.src = b.dataset.img; }
        b.addEventListener('click', function () {
          swatches.forEach(function (x) { x.classList.remove('is-active'); x.setAttribute('aria-pressed', 'false'); });
          b.classList.add('is-active');
          b.setAttribute('aria-pressed', 'true');
          if (idIn) idIn.value = b.dataset.id;
          price = parseInt(b.dataset.price, 10);
          available = b.dataset.available === 'true';
          if (colorName) colorName.textContent = b.dataset.title;
          if (selColor) selColor.textContent = b.dataset.title;
          if (img && b.dataset.img && img.getAttribute('src') !== b.dataset.img) {
            img.classList.add('is-fading');
            setTimeout(function () {
              img.onload = function () { img.classList.remove('is-fading'); };
              img.src = b.dataset.img;
              img.alt = b.dataset.alt || '';
              setTimeout(function () { img.classList.remove('is-fading'); }, 400);
            }, 160);
          }
          refresh();
        });
      });
    });
  }

  function initAll(root) {
    initReveal(root);
    initCompare(root);
    initPackColors(root);
    initCarousels(root);
    initProduct(root);
    initParallax();
    runParallax();
  }

  document.addEventListener('DOMContentLoaded', function () {
    initHeader();
    initAll(document);
    var ticking = false;
    window.addEventListener('scroll', function () {
      if (ticking) return;
      ticking = true;
      requestAnimationFrame(function () { runParallax(); ticking = false; });
    }, { passive: true });
    window.addEventListener('resize', runParallax);
  });

  // Editor de Shopify: re-iniciar al editar secciones
  document.addEventListener('shopify:section:load', function (e) { initAll(e.target); });
})();
